import { FC } from 'react';
import { DecimalComparision } from '@servicetitan/application-data/marketing';
import { Perform } from './perform';

interface PerformGreaterLessInputProps {
    name: string;
    value: DecimalComparision | undefined;
}

export const PerformGreaterLessInput: FC<PerformGreaterLessInputProps> = ({
    value,
    name,
}: PerformGreaterLessInputProps) => {
    const text = value ? `${value.type} than $${value.value}` : '';
    return <Perform name={name} text={text} />;
};
